var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":"Cultural History","prepend-icon":"mdi-magnify","dense":"","outlined":"","clearable":"","background-color":"white"},on:{"change":function($event){return _vm.$emit('input', _vm.filter)}},model:{value:(_vm.culturalHistoryTerm),callback:function ($$v) {_vm.culturalHistoryTerm=$$v},expression:"culturalHistoryTerm"}})
}
var staticRenderFns = []

export { render, staticRenderFns }